module.exports = __webpack_public_path__ + "static/img/day.d888c27f.png";